import React, { FC, memo, useCallback } from 'react'
import { CheckboxProps } from '../../utils/core.types'
import { styleForCheckbox } from './Checkbox.presenter'
import { CheckboxStyled, Label } from './Checkbox.styled'

interface Props extends CheckboxProps {
    name: string
    onClick: (res: boolean) => void
    label?: string
    labelColor?: string
    labelFontSize?: string
    required?: boolean
}

// TODO: Deprecated component, use mui/Checkbox instead
export const Checkbox: FC<Props> = memo(
    ({
        name,
        onClick,
        checked,
        borderColor,
        label,
        labelColor,
        labelFontSize,
        isBig,
        isHighlighted,
        required,
        disabled,
        getIcon,
    }) => {
        const onChange = useCallback(() => {
            if (!disabled) {
                onClick(!checked)
            }
        }, [onClick, checked])

        let style = styleForCheckbox(checked, required, disabled, isHighlighted)

        if (borderColor) style = { ...style, borderColor }

        return (
            <>
                <CheckboxStyled
                    {...style}
                    type="checkbox"
                    id={name}
                    name={name}
                    checked={checked}
                    onChange={onChange}
                    isBig={isBig || false}
                    getIcon={getIcon}
                />

                <Label
                    color={labelColor}
                    labelFontSize={labelFontSize}
                    htmlFor={name}
                    onClick={(evt) => {
                        evt.stopPropagation()
                    }}
                >
                    {label || ''}
                </Label>
            </>
        )
    }
)
